import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Bu resim için alternatif metin eksik',
    noAnswers: 'Cevap seçeneği yok, devam etmek için lütfen sonraki düğmesine tıkla.',
    placeholder: 'Lütfen belirtin...',
    pleaseSelect: 'Lütfen seçin...',
    rotateLandscape: 'Lütfen telefonunuzda yön kilidini kapatın ve devam etmek için yatay konuma çevirin.',
    rotatePortrait: 'Lütfen telefonunuzu manzaradan portreye döndürün.',
    ir: {
      selectWebCam: "Web kamerasını seç (varsa) veya cihazından yüklemek için 'Gözat' düğmesine tıkla",
      noWebCam: 'Web kamerası algılanmadı',
      accessCamUpload: 'KAMERAYA ERİŞİM SAĞLA/YÜKLE',
      browse: 'GÖZAT',
      uploadPhoto: 'Fotoğraf yükle',
      instead: 'onun yerine',
      capture: 'YAKALA',
      somethingWrong: 'Üzgünüz, bir şeyler ters gitti. Lütfen daha sonra tekrar dene',
      couldntRead: 'Üzgünüz, kodu okuyamadık!',
      couldntProcess: 'Üzgünüz, resmini işleyemedik!',
      moveOn: 'Lütfen tekrar dene veya fotoğrafını göndererek devam et',
      tryAgain: 'Lütfen tekrar dene',
      dataReceived: 'Veri alındı!',
      enterManually: 'Lütfen tekrar dene veya veriyi aşağıda elle gir',
      positionQR:
        'Lütfen QR kodunu kırmızı çerçeveye sığacak şekilde kameranın önünde konumlandır veya bilgisayarından yükle.',
      analyzing: 'Resim analiz ediliyor, lütfen bekle',
      submit: 'GÖNDER',
      startOver: 'Yeniden başlayın',
      allDone: 'Hepsi tamamlandı!',
      cantAnalyze:
        'Uyarı - bu görüntüyü işleyemedik. Lütfen tekrar göndermeyi dene veya daha jenerik bir görüntü biçimi (JPG, PNG, GIF, BMP) seç',
      wrongFormat:
        'Üzgünüz - bu dosya biçimini desteklemiyoruz. Lütfen desteklenen bir görüntü türü (JPG, PNG, GIF, BMP, TIF, PDF, SVG) yükle'
    },
    vr: {
      noWebCam: 'Web kamerası algılanmadı',
      uploadVideo: 'Video yükle',
      skip: 'Atla?',
      accessCamUpload: 'KAMERAYA ERİŞİM SAĞLA/YÜKLE',
      browse: 'GÖZAT',
      instead: 'onun yerine',
      or: 'veya',
      stopRecording: 'Kaydı durdurun',
      willBeStopped: 'Kayıt 5 dakikada duracak',
      stopOnDone: 'Tamamladığınızda kaydı durdurun!',
      record: 'KAYDET',
      somethingWrong: 'Üzgünüz, bir şeyler ters gitti. Lütfen daha sonra tekrar dene',
      microphone: 'Mikrofon',
      camera: 'Web Kamera',
      selectMicrophone: 'Mikrofonunu seç',
      selectCam: 'Web kameranı seç',
      upload: 'YÜKLE',
      playback: 'Kayıttan çalın',
      stopPlayback: 'DURDUR OYNATMA',
      submit: 'GÖNDER',
      startOver: 'Yeniden başlayın',
      allDone: 'Hepsi tamamlandı!',
      alternativeRecordSpan: 'Lütfen, bilgisayarınızdan-cihazınızdan bir video-klip yükleyin.<br/>Alternatif  &nbsp;',
      alrenativeRecordHref: 'olarak videoyu bir video kamerasıyla kaydedebilirsiniz.',
      cantAnalyze:
        'Uyarı - bu videoyu işleyemedik. Lütfen tekrar göndermeyi dene veya daha jenerik bir video biçimi (MP4, M4V, WEBPM) seç',
      wrongFormat:
        'Üzgünüz - bu dosya biçimini desteklemiyoruz. Lütfen desteklenen bir video türü  (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV) yükle'
    },
    cjc: {
      choose: 'SEÇ',
      pleaseChoose: 'Lütfen seç',
      this: 'BU',
      one: 'bir',
      myChoice: 'Benim TERCİHİM'
    },
    hm: {
      addComment: 'Lütfen aşağıya bir yorum ekleyin ',
      commentMandatoryPlaceHolder: 'Lütfen zorunlu yorum ekleyin… ',
      commentOptionalPlaceHolder: 'Lütfen isteğe bağlı yorum ekleyin… ',
      dragPin: 'Yeniden konumlandırmak için sürükleyin (tam pinleme için uzun tıklayın/dokunun',
      removePin: 'Silmek için resmin dış kısmına sürükleyin.',
      editComment: 'Yorumu düzenlemek için pine tıklayın/dokunun.',
      addPin: 'Lütfen aşağıdaki panelden pini sürükleyin ve resmin üzerinde seçtiğiniz bir noktaya bırakın.',
      addPins: 'Lütfen aşağıdaki panelden pinleri sürükleyin ve resmin üzerinde seçtiğiniz bir noktaya bırakın. ',
      leavePins: (minPoints, maxPoints) => `Lütfen her türden en az ${minPoints} ve en fazla ${maxPoints} pin bırakın.`,
      leavePinsPerPage: (minPoints, maxPoints) => `Lütfen en az ${minPoints} en fazla ${maxPoints} pin bırakın.`,
      leavePinsWithOff: maxPoints =>
        `Lütfen her türden en fazla ${maxPoints} pin bırakın veya atlamak için Sonraki düğmesine tıklayın.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Lütfen en fazla ${maxPoints} pin bırakın veya atlamak için Sonraki düğmesine tıklayın.`,
      leavePinWithOff: 'Lütfen her türden en fazla 1 pin bırakın veya atlamak için Sonraki düğmesine tıklayın.',
      leavePinPerPageWithOff: 'Lütfen en fazla 1 pin bırakın veya atlamak için Sonraki düğmesine tıklayın.',
      leaveExactlyPin: 'Lütfen her türden 1 pin bırakın. ',
      leaveExactlyPinPerPage: 'Lütfen 1 pin bırakın. ',
      leaveExactlyPins: maxPoints => `Lütfen her türden ${maxPoints} pin bırakın.`,
      leaveExactlyPinsPerPage: maxPoints => `Lütfen ${maxPoints} pin bırakın.`,
      leaveComment: 'Yorum bırakmak için resmin altına yazın. ',
      noAnswers: 'Cevap seçeneği yok, devam etmek için lütfen sonraki düğmesine tıklayın.',
      outOfPins: 'Pininiz kalmadı',
      pinsBehavior: 'Resimde gezinirken tek bir işaretçi ile öne çıkarılan alanları göreceksiniz.',
      clusters: 'İşaretçiyi sadece bu alanlara ekleyebileceksiniz.',
      contentAware: 'İşaretçiyi öne çıkarılan alanların içine veya dışına ekleyebilirsiniz.'
    },
    mp: {
      expand_note: 'Genişletmek için lütfen resimin/resimlerin üzerine gelin ya da üzerine tıklayın',
      rb_note: rows => `Lütfen aşağıdaki her madde için sadece 1 yanıt${rows ? ' seçin' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Kryssa i alla giltiga alternativ:'
        } else if (min === max) {
          return `Lütfen aşağıdaki her madde için ${min !== 1 ? 'herhangi' : 'sadece'} ${min} yanıt${
            min !== 1 ? 'lar' : ''
          }${rows ? ' seçin' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Lütfen aşağıda her madde için en az ${min} yanıt${min !== 1 ? 'lar' : ''} en fazla ${max} yanıt${
            rows ? ' seçin' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Lütfen aşağıda her madde için en az ${min} yanıt${min !== 1 ? 'lar' : ''}${rows ? ' seçin' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Lütfen aşağıda her madde için en fazla ${max} yanıt${max !== 1 ? 'lar' : ''}${rows ? ' seçin' : ''}:`
        } else {
          return 'Kryssa i alla giltiga alternativ:'
        }
      }
    },
    sh: {
      note: 'Yakınlaştırmak istediğin ürünün üzerine tıkla ve mağazada satın alacaksan sanal sepetine ekle',
      amazonNote: 'Yakınlaştırmak ve sanal sepetinize eklemek için bir ürüne tıklayın.',
      fullCart: 'Sepetin dolu!',
      qty: 'MİKTAR',
      addToCart: 'SEPETE EKLE',
      deleteFromCart: 'SİL',
      emptyCard: 'Sepetin boş',
      each: 'her biri',
      items: 'öğeler',
      total: 'Sepet',
      clearCart: 'Sepeti temizle',
      backToStore: 'Mağazaya geri dön',
      next: 'SONRAKİ',
      na: 'Yukarıdakilerden hiçbiri',
      maxCartCountError: max => `Lütfen ürün sepetinize en fazla ${max} ürün ekleyin`,
      scrollError: `Ankette ilerlemek için lütfen tamamen sola ve sağa kaydırın. `,
      maxSpentError: max => `Lütfen ${max} tutarından fazla harcamayın.`,
      maxProductCountError: max => `Lütfen her ürün için sepetinize en fazla ${max} adet ekleyin.`
    },
    rb: {
      note: 'Lütfen sadece 1 tanesini seçin:'
    },
    vo: {
      note: 'Lütfen videoyu sonuna kadar izleyin'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Lütfen ${min !== 1 ? 'herhangi' : 'sadece'} ${min} tanesini seçin:`
        } else if (min > 0 && max < 5000) {
          return `Lütfen en az ${min} en fazla ${max} tanesini seçin:`
        } else if (5000 === max && min > 0) {
          return `Lütfen en az ${min} tanesini seçin:`
        } else if (0 === min && max < 5000) {
          return `Lütfen en fazla ${max} tanesini seçin:`
        } else {
          return 'Uygun olanların hepsini işaretleyin:'
        }
      }
    },
    oe: {
      na: 'Uygulanamaz',
      note: (min, max, optional) => {
        if (min === max) {
          return `Lütfen ${1 !== min ? 'herhangi' : 'tam olarak'} ${min} karakter girin${
            optional ? ' (isteğe bağlı)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Lütfen en az ${min}, en fazla ${max} karakter girin${optional ? ' (isteğe bağlı)' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Lütfen en az ${min} karakter girin${optional ? ' (isteğe bağlı)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Lütfen en fazla ${max} karakter girin${optional ? ' (isteğe bağlı)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Lütfen aşağıdaki alanları doldur:'
    },
    mx: {
      note: 'Devam etmek için lütfen vurgulanmış kaydırıcıları hareket ettir',
      dragSlider: 'Cevaplamak için sola veya sağa sürükleyin'
    },
    psc: {
      dragLeftRight: 'Cevaplamak için sola veya sağa sürükleyin'
    },
    ps: {
      note: value => `Lütfen kalan ${value} değerlerini aşağıdakiler arasında dağıtın`,
      allDone: 'Hepsi tamamlandı!',
      total: `Toplam:`,
      dragSlider: 'Cevaplamak için sola veya sağa sürükleyin'
    },
    cx: {
      note: 'Otomatik olarak kaydırmak için cevabınızı yazmaya başlayın veya el ile seçin'
    },
    ro: {
      note: 'Yeniden sıralamak için yukarı veya aşağı kaydırın:'
    },
    md: {
      note1:
        'Lütfen ilk tercihiniz olan ögeye tıklayın/dokunun<br/>Seçiminizi temizlemek için tekrar tıklayın/dokunun.',
      note2: 'Şimdi son tercihiniz olan ögeye tıklayın/dokunun<br/>Seçiminizi temizlemek için tekrar tıklayın/dokunun.',
      note3:
        'Teşekkürler! Sonraki soruya devam edin veya baştan<br/>başlamak için seçilmemiş herhangi bir ögeye tıklayın/dokunun.'
    },
    aro: {
      note: 'Lütfen her çift için bir tanesini seçin.'
    },
    wd: {
      note: 'Lütfen her bir değerin bir öncekinden daha büyük olduğuna emin olun.'
    },
    emd: {
      note: 'Lütfen videoyu sonuna kadar izleyin',
      noAnswers: 'Cevap seçeneği yok, devam etmek için lütfen sonraki düğmesine tıkla',
      start: 'Başlamak için tıkla ve basılı tut',
      resume: 'Devam etmek için tıkla ve basılı tut',
      continue: 'Hazırsın! <br />Devam etmek için sonraki düğmesine tıkla',
      continueMobile: 'Hazırsın! <br /> Devam etmek için BURAYA tıkla',
      training: {
        session: 'Eğitim Oturumu',
        note: 'Lütfen eğitimi bitir',
        moveLeft: 'Lütfen kadranı tamamen sola sürükle',
        moveBottom: 'Lütfen kadranı tamamen aşağı sürükle',
        moveRight: 'Lütfen kadranı tamamen sağa sürükle',
        moveTop: 'Lütfen kadranı tamamen yukarı sürükle',
        success: 'Harika iş çıkardın!'
      }
    },
    sft: {
      noAnswers: 'Cevap seçeneği yok, devam etmek için lütfen sonraki düğmesine tıkla',
      note: 'Lütfen sezgisel olarak doğru hissettiren cevapla elinden geldiğince hızlı yanıtla',
      finish: 'İşin bitti! <br /> Devam etmek için lütfen Sonraki düğmesine tıkla',
      training: {
        start:
          '<p>Bu soruda sana hızlıca farklı sözcükler gösterilecek ve konsantrasyonuna gerek duyulacaktır. ' +
          'Cevaplamak için hızlı davranman gerekecek. </p> <p>Pratik yapmaya hazır mısın?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `"{buttonLeft}" düğmesine dokun`
            : (mouse ? `"{buttonLeft}" düğmesine tıkla` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `F tuşuna bas` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `"{buttonRight}" düğmesine dokun`
            : (mouse ? `"{buttonRight}" düğmesine tıkla` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `J tuşuna bas` : ''),
        fail: () => 'Çok yavaş',
        success: () => 'Harika!',
        finish: () =>
          '<p><strong> Muhteşem!</strong></p><p>Lütfen önümüzdeki 2-3 dakika <br />' +
          'içinde dikkatinin <br/> dağılmayacağından emin ol. </p><p>Hazır olduğunda başlamak için Sonraki düğmesine tıkla.</p>'
      },
      buttons: {
        start: 'Başla',
        yesno: {
          left: 'Evet',
          right: 'Hayır'
        },
        matches: {
          left: 'Eşleşme',
          right: 'Eşleşme Değil'
        },
        fits: {
          left: 'Uygun',
          right: 'Uygun Değil'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
